export { default } from './BottomControls';